var Base = require('_js/base'),
  ko = require('knockout');

function BlockModel() {
  this.authorizationDate = ko.observable();
}

function BlockUnAuthorized() {
  this.init();
}
BlockUnAuthorized.prototype = new Base();

BlockUnAuthorized.prototype.init = function() {
  var $blocks = $('[data-block-unauthorized]');

  $blocks.each(function() {
    ko.applyBindings(new BlockModel(), this);
  });
};

module.exports = BlockUnAuthorized;
